import { FirestoreDocTag, FirestoreDocUser } from "breadcommon";
import { createContext, useEffect, useState } from "react";
import { firestoreTagsSubscribe } from "./firestoreIo";

export const TagsContext = createContext<Map<string, FirestoreDocTag>>(
  new Map(),
);

export function TagsContextProvider(props: {
  children: JSX.Element;
  user: FirestoreDocUser;
  markInitialLoadComplete: () => void;
}): JSX.Element {
  const [tags, setTags] = useState<Map<string, FirestoreDocTag>>(new Map());

  useEffect(() => {
    return firestoreTagsSubscribe(
      props.user.uid,
      setTags,
      props.markInitialLoadComplete,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user.uid]);

  return (
    <TagsContext.Provider value={tags}>{props.children}</TagsContext.Provider>
  );
}
